import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SettingsService } from 'app/modules/settings/settings.service';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [ButtonModule, TranslateModule, DialogModule, InputTextModule, FormsModule, ReactiveFormsModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent implements OnInit {
  @Input() field: any;
  @Input() buttonLabel = 'Button';
  @Input() attributeLabels: [];
  @Input() moduleName: string;

  formName: FormGroup;
  placeholder: any;
  showPopup: boolean = false;
  resetPasswordGroup: FormGroup;
  header: any;

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private settingsService: SettingsService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    this.buttonLabel = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.label`, this.attributeLabels, null);
    this.header = this.cs.getLabel('lbl_confirm_action')

    this.resetPasswordGroup = this.fb.group({
      value: ['', [Validators.required]]
    });
  }

  btnClick() {
    this.resetPasswordGroup.reset();
    this.showPopup = true;
  }

  setValue() {
    const resetValue = this.resetPasswordGroup.controls.value.value;
    const payload = {};
    if (resetValue === AppSettings.LABEL_RESET) {
      this.settingsService.resetAllPasswordsSecuritySettings(payload).subscribe(() => {
        this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel('password_reset_success') });
      });
      this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue(resetValue);
      this.formName.get(this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode).updateValueAndValidity();
      this.showPopup = false;
    } else {
      this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: this.cs.getLabel('error_type_reset') });
      this.btnClick();
    }
  }

}
